import { Component, Input, inject } from '@angular/core';
import { RoutingService } from '../../service/common/routing/routing.service';
import { Router } from '@angular/router';
import { NetzzuordnungFilter } from '../../service/netzzuordnung/netzzuordnung-filter';
import { TeilgebietSelectionService } from '../../service/common/teilgebiet/teilgebiet-selection.service';
import moment from 'moment';

@Component({
    selector: 'tnb-dashboard-uuid-change-confirmation',
    templateUrl: './dashboard-uuid-change-confirmation.component.html',
    styleUrls: [
        './dashboard-uuid-change-confirmation.component.scss',
    ],
    standalone: false,
})
export class DashboardUuidChangeConfirmationComponent {
    readonly router = inject(Router);
    readonly routeService = inject(RoutingService);
    readonly teilgebietSelectionService = inject(TeilgebietSelectionService);

    @Input() public numberOfUnconfirmedNetzzuordnungen: number;

    @Input() public lastConfirmedUuidDate: Date;

    public routeToNetzzuordnungPage() {
        let filter: NetzzuordnungFilter = null;
        if (this.numberOfUnconfirmedNetzzuordnungen > 0) {
            const date = moment(this.lastConfirmedUuidDate || null); // undefined means now
            filter = { uuidDateStart: date.isValid() ? date : undefined };
        }
        this.router.navigateByUrl(this.routeService.netzzuordnungTable(null, filter));
    }


}
